//
// Recovery Controller

recoveryController = function () {
  var _recoveryPopupOpen = false;
  var _readyToStart = false;
  var _recoveryTask = {};
  var _recoveryPopupTranslationPhrase = "";

  this.initialise = function (json) {
    _recoveryPopupTranslationPhrase = json.recoveryPopupTranslationPhrase;

    if (checkForUndefined(_recoveryPopupTranslationPhrase))
      console.log(
        "recoveryPopupTranslationPhrase undefined in recoveryController"
      );
  };

  this.notifyGameRecovery = function (task) {
    if (task.data.recoverFromStart) {
      _recoveryTask = task;
      task.join();
      okBox.showPopup(_recoveryPopupTranslationPhrase, recoveryPopupClosed);
    }
  };

  function recoveryPopupClosed() {
    messageBus.post("game:modal", {});
    _recoveryTask.leave();
    _recoveryPopupOpen = false;
  }

  Object.defineProperty(this, "RecoveryPopupOpen", {
    get: function () {
      return _recoveryPopupOpen;
    },
  });

  messageBus.subscribe("common:RecoverGame", this.notifyGameRecovery);
};

resourceManager.registerController("recoveryController", function () {
  return new recoveryController();
});
